import axios from "axios";

var { apiUrl } = window.config;
export async function updatePassword(Username, Password) {
  try {
    const token = localStorage.getItem("AccessToken");
    const response = await axios.post(
      `${apiUrl}/api/login/updatePassword`,
      { Username, Password, UserModified: Username },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "Application/json",
          Authorization: `${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    if (error.response) {
      return error.response;
    } else {
      throw new Error("Network Error");
    }
  }
}
